import { EUserPermissions } from '@zunta/configurations'

const meta = {
  requiresAuth: true,
  managementOnly: true
}

export default [
  {
    name: 'management-facilities-login',
    path: 'facilities/login',
    meta: { ...meta, permissions: [EUserPermissions.ADD_FACILITY] },
    component: () => import('@/views/app/management/settings/pages/facility/shared/PccLogin.vue')
  },
  {
    name: 'management-facilities-import',
    path: 'facilities/import',
    meta: { ...meta, permissions: [EUserPermissions.ADD_FACILITY] },
    component: () => import('@/views/app/management/settings/pages/facility/shared/PccImport.vue')
  },
  {
    name: 'management-facilities-agreements',
    path: 'facilities/agreements',
    meta: { ...meta, permissions: [EUserPermissions.ADD_FACILITY] },
    component: () => import('@/views/app/management/settings/pages/facility/shared/AcceptAgreements.vue')
  }
]
